import { useEffect } from 'react';
import { StringParam, useQueryParam } from 'use-query-params';
import { useStore } from 'app/context';

/**
 * Bridges a single `agtId` query string parameter into the tree store's single-agt selection.
 *
 * Reports like "Bestand und Bewertung" and "Agenturbestand im 5-Jahresverlauf" toggle between a
 * list view and a single-agent view based on `berichteUiiStore.selectedAgt`, which is derived from
 * `currentFilter.singleSelectedAgtId` (see TreePathLoader). That observable is normally only set by
 * the Agt-Selector button, so navigating to these reports directly via `?agtId=` (link, reload, or
 * the list row click) would otherwise be ignored until the button was used.
 *
 * Only a single agtId is honoured; a comma-separated (multi) value is treated as no single selection
 * so it does not fight the general list filter. Cleared on unmount by BerichteContainer.
 */
export const useSelectSingleAgtFromQuery = () => {
	const { agenturListUiStore } = useStore();
	const [agtIdQuery] = useQueryParam('agtId', StringParam);

	useEffect(() => {
		const isSingle = !!agtIdQuery && !agtIdQuery.includes(',');
		const agtId = isSingle ? parseInt(agtIdQuery!, 10) : NaN;
		agenturListUiStore.currentFilter.selectSingleAgtId(isNaN(agtId) ? undefined : agtId);
	}, [agtIdQuery, agenturListUiStore]);
};
